<app-autocomplete-select
  [formControl]="control"
  [options]="options"
  [optionScope]="countryIso || countryId"
  [searchFn]="search"
  [preloadFn]="preload"
  [placeholder]="placeholder"
  [selectClass]="selectClass"
  (blur)="touched()">
</app-autocomplete-select>
